import React, { Dispatch, SetStateAction } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import AssetsSubNav from './SubNavComponents/AssetsSubNav';
import CampaignsSubNav from './SubNavComponents/CampaignsSubNav';
import SettingsSubNav from './SubNavComponents/SettingsSubNav';
import UserManagementSubNav from './SubNavComponents/UserManagementSubNav';
import { FileManagementSubNav } from './SubNavComponents/FileManagementSubNav';
import { ComplianceSubNav } from './SubNavComponents/ComplianceSubNav';
import { DashboardSubNav } from './SubNavComponents/DashboardSubNav';

export interface SubNavProps {
  clientId: string;
  level: string;
  setHeading?: Dispatch<SetStateAction<string>>;
}

export const SubNavLinks: React.FC<SubNavProps> = props => {
  const location = useLocation();
  const isSettings = useRouteMatch({ path: '/:level/:id/settings' });
  const isCampaigns = useRouteMatch({ path: '/:level/:id/campaigns' });
  const isFileManagement = useRouteMatch({ path: '/file-management' });
  const isUserManagement = useRouteMatch({ path: '/user-management*' });
  const isAssetsSiteLevel = useRouteMatch({ path: '/:level/:id/designs' });
  const isAssets = useRouteMatch({ path: '/designs' });
  const isCompliance = useRouteMatch({ path: '/:level/:id/compliance' });
  const isRootDashboard = useRouteMatch({ path: '/', exact: true });

  return (
    <>
      {isSettings && <SettingsSubNav {...props} />}
      {isCampaigns && <CampaignsSubNav {...props} />}
      {isFileManagement && <FileManagementSubNav {...props} />}
      {isUserManagement && <UserManagementSubNav {...props} />}
      {(isAssetsSiteLevel || isAssets) && <AssetsSubNav {...props} />}
      {isCompliance && <ComplianceSubNav {...props} />}
      {(isRootDashboard || location.pathname.includes('/dashboard')) && (
        <DashboardSubNav {...props} path="/dashboard" />
      )}
    </>
  );
};
